import { view } from '@yola/ws-sdk';
import parseItemsFromDOM from './parse-items-from-dom';

const getFields = (elementId) => {
  const container = view.accessors.getLiveElement(elementId);
  const items = parseItemsFromDOM(container);

  return items.map((field) => {
    if (field.options) {
      return {
        ...field,
        options: field.options.map((option) => ({ option })),
      };
    }

    return field;
  });
};

export default getFields;
